import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import InstallationSection from './components/InstallationSection';
import ComparisonSection from './components/ComparisonSection';
import CostSavingsSection from './components/CostSavingsSection';
import SpecsSection from './components/SpecsSection';
import MarketDataSection from './components/MarketDataSection';
import UseCasesSection from './components/UseCasesSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

const HomePage = () => {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <InstallationSection />
        <ComparisonSection />
        <CostSavingsSection />
        <SpecsSection />
        <MarketDataSection />
        <UseCasesSection />
        <CTASection />
      </main>
      <FooterSection />
    </div>
  );
};

export default HomePage;
